import styled from 'styled-components';
import { SbButton, SbCard } from 'uiCore';

export const FeedbackCardStyled = styled(SbCard)`
    width: 100%;
`;

export const SubmitBtnStyled = styled(SbButton)`
    justify-content: center;
`;

export const UploadBtnStyled = styled(SbButton)`
    background: ${p => p.theme?.colors?.primary || '#008080'} !important;
    border-color: ${p => p.theme?.colors?.primary || '#008080'} !important;
    color: #fff !important;

    &:disabled {
        opacity: 0.5;
    }
`;

export const TooltipAnchorStyled = styled.span`
    display: inline-block;
`;

export const RatingBtnStyled = styled(SbButton)`
    border-color: ${p =>
        p.$active === 'up'
            ? p.theme?.colors?.primary || '#008080'
            : p.$active === 'down'
                ? p.theme?.colors?.danger
                : p.theme?.colors?.border || '#D8DAE5'} !important;
    background: ${p =>
        p.$active === 'up'
            ? p.theme?.colors?.secondary || '#DDEAEA'
            : p.$active === 'down'
                ? 'rgba(220, 38, 38, 0.08)'
                : p.theme?.colors?.white} !important;
    color: ${p =>
        p.$active === 'up'
            ? p.theme?.colors?.primary || '#008080'
            : p.$active === 'down'
                ? p.theme?.colors?.danger
                : 'inherit'} !important;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
`;

